import { render, staticRenderFns } from "./GroupDelivery.vue?vue&type=template&id=d6fdf136"
import script from "./GroupDelivery.vue?vue&type=script&lang=js"
export * from "./GroupDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports